import { useCallback } from 'react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
// import { useDialog } from 'src/context/DialogProvider';
import { HOST_API } from 'src/config-global';
// locales
// import { useLocales } from 'src/locales';
import { enqueueSnackbar } from 'notistack';

interface ServerResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}

// Set the base URL for all Axios requests
axios.defaults.baseURL = `${HOST_API}`;

export function useServerRequest() {
  // const { openDialog } = useDialog();
  // const { t } = useLocales();

  const makeRequest = useCallback(
    async <T = any>(
      url: string,
      config: AxiosRequestConfig,
      successMessage?: string
    ): Promise<ServerResponse<T>> => {
      try {
        const currentLang = localStorage.getItem('i18nextLng') || 'en';
        const headers = {
          'X-App-Language': currentLang,
        };
        const response: AxiosResponse<T> = await axios({ url, ...config, headers });
        // const response: AxiosResponse<T> = await axios({ url, ...config });

        if (response.status >= 200 && response.status < 300) {
          if (successMessage && successMessage !== '-') {
            enqueueSnackbar(successMessage, {variant: 'success', key: new Date().getTime() });
          }else if (successMessage && successMessage === '-'){
            //
          }else{
            enqueueSnackbar('The operation went successfull!', {variant: 'success', key: new Date().getTime() });
          }
          return {
            success: true,
            data: response.data,
          };
        }

        // Handle unexpected status codes
        // openDialog('ERROR_DIALOG', { message: `Unexpected response code: ${response.status}` });
        enqueueSnackbar('Unexpected error occurred!', {variant: 'error', key: new Date().getTime() });
        return {
          success: false,
          error: `Unexpected code: ${response.status}`,
        };
      } catch (error: any) {
        console.log(error);
        
        const errorMessage = 'An unexpected error occurred.';
        enqueueSnackbar('An unexpected error occurred!', {variant: 'error', key: new Date().getTime() });

        // if (axios.isAxiosError(error)) {
        //   if (error.response) {
        //     switch (error.response.status) {
        //       case 400:
        //         errorMessage = 'Bad Request. Please check your input and try again.';
        //         break;
        //       case 401:
        //         errorMessage = 'Unauthorized. Please log in and try again.';
        //         break;
        //       case 403:
        //         errorMessage = 'Forbidden. You do not have permission to perform this action.';
        //         break;
        //       case 404:
        //         errorMessage = 'Resource not found. The requested resource could not be found on the server.';
        //         break;
        //       case 422:
        //         errorMessage = `${t(`${error.response.data.message}`)}`;
        //         break;
        //       case 500:
        //         errorMessage = 'Server Error. We are working on it. Please try again later.';
        //         break;
        //       case 503:
        //         errorMessage = 'Service Unavailable. The server is currently unavailable. Please try again later.';
        //         break;
        //       default:
        //         errorMessage = `Unexpected server error: ${error.response.status}. Please try again later.`;
        //         break;
        //     }
        //     openDialog('ERROR_DIALOG', { message: errorMessage });
        //   } else if (error.request) {
        //     errorMessage = 'No response from the server. Please check your internet connection or try again later.';
        //     openDialog('ERROR_DIALOG', { message: errorMessage });
        //   }
        // } else {
        //   errorMessage = error.message || 'An unexpected error occurred. Please check your internet connection and try again.';
        //   openDialog('ERROR_DIALOG', { message: errorMessage });
        // }

        return {
          success: false,
          error: errorMessage,
        };
      }
    },
    []
  );

  return { makeRequest };
}
